import { type QuickStepHotkeyId } from "owa-quick-step-types";
import { hotkeyEight as Strings_hotkeyEight, hotkeyFive as Strings_hotkeyFive, hotkeyNine as Strings_hotkeyNine, hotkeySeven as Strings_hotkeySeven, hotkeySix as Strings_hotkeySix, } from "./getHotkeyDropdownOptions.locstring.json";
import loc, { type LocalizedString } from "owa-localize";

export function getQuickStepHotkeyText(hotkey: QuickStepHotkeyId | undefined): LocalizedString | undefined {
    switch (hotkey) {
        case 0:
            return loc(Strings_hotkeyFive);
        case 1:
            return loc(Strings_hotkeySix);
        case 2:
            return loc(Strings_hotkeySeven);
        case 3:
            return loc(Strings_hotkeyEight);
        case 4:
            return loc(Strings_hotkeyNine);
        default:
            return undefined;
    }
}
